import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/registroCoempaque';
import Registros from './RegistroCoempaqueList';


const ms2p = (state) => {
  return {
    ...state.rs_registro_coempaque,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Registros);
